import React, { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { FileDoc } from 'phosphor-react';
import { useTemplateDoEvento } from '../../../../hooks/useEventoContrato';
import TemplateDoEvento from './TemplateDoEvento';

/**
 * Faixa no topo da coluna CONTRATO do board do evento: é ONDE se define o
 * template de contrato, uma vez por evento. Sem o template do tipo do contrato
 * confirmado, o botão "Gerar contrato" do card fica desabilitado — a faixa diz o
 * porquê e leva lá.
 */
export default function FaixaTemplateDoEvento({ eventoId }: { eventoId: number }) {
  const [aberto, setAberto] = useState(false);
  const { data } = useTemplateDoEvento(eventoId);
  const info = data?.data;
  const qtd = info?.templates.length ?? 0;
  const campos = (info?.templates ?? []).reduce((n, t) => n + (t.mapa?.campos?.length ?? 0), 0);
  // Cada tipo de contrato (serviço, produto, parceria...) tem os seus arquivos.
  const comArquivo = (info?.tipos ?? []).filter(t => t.arquivos > 0);
  // Um tipo pendente não trava os outros: a faixa diz qual falta confirmar.
  const pendentes = comArquivo.filter(t => !t.confirmado).map(t => t.rotulo.toLowerCase());
  const ok = !!info?.confirmado;
  let rotulo = 'Defina o template de contrato do evento';
  if (ok)
    rotulo = `Template do evento · ${qtd} arquivo(s)${comArquivo.length > 1 ? ` de ${comArquivo.length} tipos` : ''} · ${campos} campos · confirmado`;
  else if (pendentes.length)
    rotulo = `Template do evento · confira e confirme: ${pendentes.join(', ')}`;
  else if (qtd) rotulo = 'Template do evento · confira e confirme o mapa';

  return (
    <>
      <Flex
        as="button"
        type="button"
        w="100%"
        px={4}
        py={2}
        gap={2}
        align="center"
        textAlign="left"
        bg={ok ? 'green.50' : 'orange.50'}
        borderTop="1px solid"
        borderColor={ok ? 'green.100' : 'orange.100'}
        _hover={{ bg: ok ? 'green.100' : 'orange.100' }}
        onClick={() => setAberto(true)}
      >
        <FileDoc size={14} color={ok ? '#38A169' : '#DD6B20'} />
        <Text fontSize="11px" color="gray.700" flex={1} lineHeight="1.3">
          {rotulo}
        </Text>
      </Flex>
      <TemplateDoEvento eventoId={eventoId} isOpen={aberto} onClose={() => setAberto(false)} />
    </>
  );
}
